export function parseDiscountPercentage(
  value: string | number | null | undefined,
) {
  if (typeof value === "number") {
    return value > 0 ? value : null;
  }

  if (!value) {
    return null;
  }

  const parsed = Number.parseFloat(value.replace(/%/g, "").trim());

  if (Number.isNaN(parsed) || parsed <= 0) {
    return null;
  }

  return parsed;
}

export function formatDiscountPercentage(
  value: string | number | null | undefined,
) {
  const parsed = parseDiscountPercentage(value);

  if (parsed === null) {
    return "";
  }

  return `${Number.parseFloat(parsed.toFixed(2))}%`;
}

export function formatDiscountLabel(
  value: string | number | null | undefined,
  prefix = "خصم",
) {
  const formattedPercentage = formatDiscountPercentage(value);

  if (!formattedPercentage) {
    return "";
  }

  return `${prefix} ${formattedPercentage}`;
}
